export default function(req, res, next) {
	const enabledSections = process.env.LINE_OF_BUSINESS.split(',').map(s => s.trim()).filter(Boolean);
	const firstSection = enabledSections[0];
	const defaultDash = `/${firstSection}/${firstSection}_dash`;

	const redirects = [
		{
			from: '/',
			to: defaultDash
		}
	]
	const redirect = redirects.find((r) => r.from === req.url)
	if (redirect) {
		res.writeHead(301, { Location: redirect.to })
		res.end()
	} else {
		next()
	}
}
